import React from 'react';
import PropTypes from 'prop-types';

// HTML UNICODE FOR DEGREES FAHRENHEIT
// /////////////////////// //
// ////// &#8457; //////// //
// /////////////////////// //

export default function AverageWeather() {
  return (
    <div className="average-table-container">
      <table className="average-table">
        <tbody>
          <tr className="table-row">
            <td className="table-row-label">High Temp</td>
            <td className="table-row-data high">
              <span>{61}</span>&#8457;
            </td>
            <td className="table-row-data high">
              <span>{63}</span>&#8457;
            </td>
            <td className="table-row-data high">
              <span>{68}</span>&#8457;
            </td>
            <td className="table-row-data high">
              <span>{74}</span>&#8457;
            </td>
            <td className="table-row-data high">
              <span>{82}</span>&#8457;
            </td>
            <td className="table-row-data high">
              <span>{87}</span>&#8457;
            </td>
            <td className="table-row-data high">
              <span>{89}</span>&#8457;
            </td>
            <td className="table-row-data high">
              <span>{89}</span>&#8457;
            </td>
            <td className="table-row-data high">
              <span>{86}</span>&#8457;
            </td>
            <td className="table-row-data high">
              <span>{79}</span>&#8457;
            </td>
            <td className="table-row-data high">
              <span>{70}</span>&#8457;
            </td>
            <td className="table-row-data high">
              <span>{62}</span>&#8457;
            </td>
          </tr>

          <tr className="table-row">
            <td className="table-row-label">Low Temp</td>
            <td className="table-row-data low">
              <span>{45}</span>&#8457;
            </td>
            <td className="table-row-data low">
              <span>{47}</span>&#8457;
            </td>
            <td className="table-row-data low">
              <span>{53}</span>&#8457;
            </td>
            <td className="table-row-data low">
              <span>{60}</span>&#8457;
            </td>
            <td className="table-row-data low">
              <span>{68}</span>&#8457;
            </td>
            <td className="table-row-data low">
              <span>{75}</span>&#8457;
            </td>
            <td className="table-row-data low">
              <span>{77}</span>&#8457;
            </td>
            <td className="table-row-data low">
              <span>{76}</span>&#8457;
            </td>
            <td className="table-row-data low">
              <span>{72}</span>&#8457;
            </td>
            <td className="table-row-data low">
              <span>{63}</span>&#8457;
            </td>
            <td className="table-row-data low">
              <span>{54}</span>&#8457;
            </td>
            <td className="table-row-data low">
              <span>{47}</span>&#8457;
            </td>
          </tr>

          <tr className="table-row">
            <td className="table-row-label">Avg Rainfall</td>
            <td className="table-row-data ppt">
              <span>{5.1}</span>in
            </td>
            <td className="table-row-data ppt">
              <span>{5.3}</span>in
            </td>
            <td className="table-row-data ppt">
              <span>{6.1}</span>in
            </td>
            <td className="table-row-data ppt">
              <span>{4.3}</span>in
            </td>
            <td className="table-row-data ppt">
              <span>{3.3}</span>in
            </td>
            <td className="table-row-data ppt">
              <span>{5.5}</span>in
            </td>
            <td className="table-row-data ppt">
              <span>{8.0}</span>in
            </td>
            <td className="table-row-data ppt">
              <span>{6.7}</span>in
            </td>
            <td className="table-row-data ppt">
              <span>{5.2}</span>in
            </td>
            <td className="table-row-data ppt">
              <span>{3.8}</span>in
            </td>
            <td className="table-row-data ppt">
              <span>{4.6}</span>in
            </td>
            <td className="table-row-data ppt">
              <span>{4.6}</span>in
            </td>
          </tr>

          <tr className="table-row">
            <td />
            <td className="table-row-label xaxis">Jan</td>
            <td className="table-row-label xaxis">Feb</td>
            <td className="table-row-label xaxis">Mar</td>
            <td className="table-row-label xaxis">Apr</td>
            <td className="table-row-label xaxis">May</td>
            <td className="table-row-label xaxis">Jun</td>
            <td className="table-row-label xaxis">Jul</td>
            <td className="table-row-label xaxis">Aug</td>
            <td className="table-row-label xaxis">Sep</td>
            <td className="table-row-label xaxis">Oct</td>
            <td className="table-row-label xaxis">Nov</td>
            <td className="table-row-label xaxis">Dec</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
